<template>
  <div>
    <el-table border v-loading="loading" :data="tableData" style="width: 100%">
      <!-- <template v-if="!examPaperId">
        <el-table-column label="所属项目" prop="projectId" align="center" width="200">
          <template slot-scope="{ row }">
            {{row.project ? row.project.projectName : '--'}}
          </template>
        </el-table-column>
      </template> -->
      <template>
        <el-table-column label="排序号" prop="projectId" align="center" width="120">
          <template slot-scope="{ row }">
            <div v-if="!row.sortNumShow">{{row.sortNum || '--'}}<i class="el-icon-edit edite_icon" @click="editeOpen(row,'sortNum')"></i></div>
            <template v-else>
              <el-input size="mini" @blur="editRadio(row, 'sortNum')" v-model.number="row.sortNum" @input="row.sortNum = Number(row.sortNum) || ''" maxlength="9" />
            </template>
          </template>
        </el-table-column>
        <!-- <el-table-column label="所属分类" prop="projectId" align="center" width="200">
          <template slot-scope="{ row }">
            {{row.classificationId ? typeData.length > 0 && typeData.find(item => item.id == row.classificationId).name : '--'}}
          </template>
        </el-table-column> -->
      </template>
      <el-table-column label="题型" align="center" width="150">
        <template slot-scope="{ row }">
          <el-tag :type="row.type == 1 ? '' : row.type == 2 ? 'success' : row.type == 3 ? 'danger' : 'info'">{{row.type | typeFilter}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="题目" prop="title" align="center" width="380">
        <template slot-scope="{ row }">
          <el-popover trigger="hover" placement="top" ref="popover" v-if="row.examOptions.length > 0" class="examOptions_cont">
            <div class="examOptions_cont">
              <div class="item" v-for="(item,index) in row.examOptions" :key="index">
                <div class="left">
                  <div class="optionName">{{item.optionName}}</div>
                  <div v-html="item.optionDescribe"></div>
                </div>
                <div class="right">
                  <el-button type="text" size="mini" @click="optionAction('edite',row.examTopicId,item)">编辑</el-button>
                  <el-button type="text" size="mini" @click="optionAction('del',row.examTopicId,item)">删除</el-button>
                </div>
              </div>
            </div>

            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ row.title }}</el-tag>
              <!-- <div class="subject_title">{{row.title}}</div> -->
            </div>
          </el-popover>
          <el-popover trigger="hover" placement="top" v-else>
            <div class="no_option">暂无选项</div>
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ row.title }}</el-tag>
              <!-- <div class="subject_title">{{row.title}}</div> -->
            </div>
          </el-popover>
          <!-- <el-tag v-else>{{row.title}}</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column label="答案" prop="answer" align="center" width="350" :formatter="fliteRData">
        <template slot-scope="{ row }">
          <el-tag type="info" size="small">{{row.answer || '--'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="分值" prop="score" align="center" width="110">
        <template slot-scope="{ row }">
          <template v-if="examPaperId">
            <div v-if="!row.scoreShow">{{row.score || 0}}<i class="el-icon-edit edite_icon" @click="editeOpen(row,'score')"></i></div>
            <template v-else>
              <el-input size="mini" @blur="editRadio(row, 'score')" v-model.number="row.score" @input="row.score = Number(row.score) || ''" maxlength="10" />
            </template>
          </template>
          <template v-else>{{row.score }}</template>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="insertDate" align="center" width="200" :formatter="fliteRData">
        <!-- examTopic -->
      </el-table-column>
      <el-table-column label="备注" prop="remarks" align="center" width="280" :formatter="fliteRData" />
      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template slot-scope="{ row }">
          <el-button type="text" size="mini" @click="action('edite',row)">编辑</el-button>
          <el-button type="text" size="mini" @click="action('addOption',row)">添加选项</el-button><br />
          <el-button type="text" size="mini" @click="action('relation',row)">查看关联</el-button>
          <template v-if="!examPaperId">
            <el-button type="text" size="mini" @click="action('guanlian',row)">关联试卷</el-button>
          </template>
          <el-button type="text" size="mini" @click="action('del',row)" v-else>删除关联</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑题目 -->
    <subjectAdd ref="subjectAdd" @update="update" />
    <!-- 添加选项 -->
    <addOption ref="addOption" @update="update" />
    <!-- 查看关联 -->
    <relation ref="relation" :examPaperId="examPaperId" />
    <!-- 关联试卷 -->
    <testPaperList ref="testPaperList" />
  </div>
</template>

<script>
import { projectMoudel, typeMoudel } from "../../mixins"
import { subjectType } from "../../dict"

import subjectAdd from "./add.vue"
import addOption from "./addOption"
import relation from "./relation.vue"
import testPaperList from "../../testPaper/com/testPaperList.vue"

import { examPaperTopicDels, examOptionDel, examTopicUpdate } from "../../api"

export default {
  props: {
    tableData: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    examPaperId: {
      type: String,
      default: null
    }
  },
  mixins: [projectMoudel, typeMoudel],
  components: { subjectAdd, addOption, relation, testPaperList },
  filters: {
    typeFilter (value) {
      if (value) {
        return subjectType.find(item => item.id == value).name || '--'
      } else {
        return '--'
      }
    }
  },
  mounted () {
    this.$refs.popover && this.$refs.popover.updatePopper()
  },
  methods: {
    optionAction (key, examTopicId, item) {
      switch (key) {
        case 'edite':
          // this.$refs.addOption.init(examTopicId,item.id,item)
          this.$refs.addOption.init({
            examTopicId,
            optionId: item.id,
            item
          })
          break;
        case 'del':
          this.$confirm('是否确定删除当前选项数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await examOptionDel({ id: item.id })
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('删除成功!')
            this.$emit('update', true)
          })
          break;
      }
    },
    editeOpen (item, key) {
      switch (key) {
        case 'score':
          this.$set(item, 'scoreShow', true)
          break;
        case 'sortNum':
          this.$set(item, 'sortNumShow', true)
          break;
        default:
          break;
      }
    },
    fliteRData (row, column, cellValue, index) {
      const _value = row[column.property]
      if (_value) {
        return _value
      } else {
        return '--'
      }
    },
    async editRadio (item, key) {
      const params = {
        examPaperId: this.$attrs.examPaperId,
      }
      if (this.examPaperId) {
        params.examPaperId = this.examPaperId
        params.id = item.examTopicId
      } else {
        params.id = item.id
      }
      if (key == 'score') {
        if (+item.score < 0) return this.$message.error('只能输入正整数')
        if (+item.score <= 0 || +item.score > 40) return this.$message.error('只能输入 1 ~ 40 范围之内的分值！')
        params.score = item.score
      } else if (key == 'sortNum') {
        if (+item.sortNum < 0) return this.$message.error('只能输入正整数')
        params.sortNum = item.sortNum
      }
      const res = await examTopicUpdate(params)
      if (res.code !== 0) return this.$message.warning(res.message)
      this.$set(item, 'scoreShow', false)
      this.$emit('update', true)
      this.$message.success('操作成功!')
    },
    update () {
      this.$emit('update', true)
    },
    action (key, item) {
      const id = this.examPaperId ? item.examTopicId : item.id
      const projectId = item.projectId
      switch (key) {
        case 'add':
          this.$refs.subjectAdd.init()
          break;
        case 'addOption':
          const arrList = [1, 2]
          if (arrList.includes(item.type)) {
            this.$refs.addOption.init({
              examTopicId: id
            })
          } else {
            this.$message.warning('温馨提示：只有选择题才能添加选项！')
          }
          break;
        case 'edite':
          this.$refs.subjectAdd.init(id)
          break;
        case 'relation':
          this.$refs.relation.init(id, item.title, projectId)
          break;
        case 'guanlian':
          this.$refs.testPaperList.init(id, projectId)
          break
        case 'del':
          this.$confirm('确定删除关联?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            const res = await examPaperTopicDels({ ids: item.id })
            if (res.code !== 0) return this.$message.warning(res.message)
            this.$message.success('删除成功!')
            this.$emit('update', true)
          })
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tag {
  cursor: pointer;
  white-space: normal;
  height: auto;
}
::v-deep .item .left > div,
p {
  display: inline-block;
}

// ::v-deep .el-popover{
//   max-height: 70%;
//   overflow: scroll;
// }

.examOptions_cont {
  max-height: 400px;
  overflow: scroll;
  background: transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #9dc3f2;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }
}

.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 6px;
  max-width: 500px;
  .left {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    .optionName {
      padding-right: 4px;
      & + div {
        flex: 1;
      }
    }
    span {
      display: inline-block;
      &:first-child {
        margin-right: 9px;
      }
    }
  }
  .right {
    text-align: center;
    padding-left: 12px;
  }
}

.subject_title {
  cursor: pointer;
  padding: 3px 6px;
  background-color: #ecf5ff;
  border-color: #d9ecff;
  color: #409eff;
  border-radius: 4px;
  box-sizing: border-box;
}
.no_option {
  text-align: center;
  color: #909399;
}

.edite_icon {
  cursor: pointer;
  margin: 0 6px;
}
</style>
